import { useQuery } from "react-query";

import { QUERY_KEYS } from "../../constants/queryKeys";
import { CasAuthApi } from "../../services";

export const useRegistrationPublicConfiguration = () => {
  const { data, isLoading } = useQuery(
    QUERY_KEYS.registrationPublicConfiguration,
    () => CasAuthApi.init().getRegistrationPublicConfiguration(),
    {
      retry: false,
      refetchOnWindowFocus: false,
    }
  );

  return {
    isBackendDeviceRegistrationMandatory: data?.requiresDeviceRegistration ?? false,
    isLoading,
  };
};
